module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c08"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v("Matching Ring and Bracelet")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("R")]), _vm._v("aymond Rashawne Carter proposed to his girlfriend in February 2005 and then surprised her with a beautiful set of wedding rings worth $1,500. She accepted his proposal, and he slipped the ring on her finger, but it was a little big. The unfazed fiancé decided to return the rings and have them resized. At the Charlottesville, Virginia, store, the clerk took the ring and then gave the police a ring. Apparently, Raymond forgot to mention that he didn’t pay for the jewelry. So procuring the ring at a five-finger discount in order to adorn his girlfriend’s ring finger, Raymond fingered himself, and I’m sure his girlfriend gave him the finger for his efforts."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L02_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_c('strong', [_vm._v("When Ruth and Kevin Kimber married in 1990, she was ninety-three and he was twenty-eight.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83979e4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c08_r1.vue
// module id = 96
// module chunks = 0